import {
    Component,
    computed,
    inject,
    input,
    TemplateRef,
} from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AppStore } from '@app/stores/appStore';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    imports: [
        MatDialogTitle,
        NgTemplateOutlet,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
    ],
})
export class ModalDialogComponent {
    private appStore = inject(AppStore);
    /** Title text for the modal header. */
    title = input<string>();
    /** sub-Title text for the modal header. */
    subtitle = input<string>();
    /** Template for the modal body */
    bodyTemplate = input<TemplateRef<Element>>();
    /** Template for the modal footer */
    footerTemplate = input<TemplateRef<Element>>();

    headerTemplate = input<TemplateRef<Element>>();

    /**
     * When set via `@Input`, overrides the store signal.
     * Otherwise, reads from `appStore.closeButtonVisibility`.
     */
    showCloseButtonOverride = input<boolean | undefined>(undefined, {
        alias: 'showCloseButton',
    });
    showCloseButton = computed(
        () =>
            this.showCloseButtonOverride() ??
            this.appStore.closeButtonVisibility()
    );

    constructor(
        private dialogRef: MatDialogRef<ModalDialogComponent>
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}
